<!-- @slot <ten-col>组件 -->
<script>
import Col from '../col';
const isServer = typeof window === 'undefined';
const name = 'ten-row';

function calSize(width) {
  let size = 'xs';
  if (width < 768) {
    size = 'xs';
  } else if (width >= 768 && width < 992) {
    size = 'sm';
  } else if (width >= 992 && width < 1200) {
    size = 'md';
  } else if (width >= 1200 && width < 1920) {
    size = 'lg';
  } else {
    size = 'xl';
  }
  return size;
}

export default {
  name,
  props: {
    /**
     * 列之间的间隔
     */
    gutter: {
      type: Number,
      default: 10,
    },
    /**
     * 所含列数
     */
    colCount: {
      type: Number,
      default: 12,
    },
    /**
     * 小于768px屏幕时的行配置，若提供数字则代表 colCount
     */
    xs: [Number, Object],
    /**
     * 768~992屏幕时的行配置，若提供数字则代表 colCount
     */
    sm: [Number, Object],
    /**
     * 992~1200屏幕时的行配置，若提供数字则代表 colCount
     */
    md: [Number, Object],
    /**
     * 1200~1920屏幕时的行配置，若提供数字则代表 colCount
     */
    lg: [Number, Object],
    /**
     * 大于1920屏幕时的行配置，若提供数字则代表 colCount
     */
    xl: [Number, Object],
  },
  data() {
    return {
      size: isServer ? 'md' : calSize(window.innerWidth),
    };
  },
  computed: {
    _class() {
      return [
        name,
      ];
    },
    _style() {
      return {
        margin: `0 ${-this.getConfig('gutter') / 2}px`,
      };
    },
  },
  mounted() {
    this.size = calSize(window.innerWidth);
    window.addEventListener('resize', this.updateSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSize);
  },
  methods: {
    updateSize() {
      this.size = calSize(window.innerWidth);
    },
    getConfig(type) {
      if (this.size && this[this.size]) {
        const config = this[this.size];
        if (typeof config === 'number' && type === 'colCount') {
          return config;
        }
        return config[type] || this[type];
      }
      return this[type];
    },
  },
  render(createElement) {
    return createElement(
      'div',
      {
        style: this._style,
        class: this._class,
      },
      this.$slots.default && this.$slots.default.map((vnode) => {
        if (vnode.tag && vnode.componentOptions.tag === 'ten-col') {
          return createElement(
            Col,
            {
              ...vnode.data,
              props: Object.assign({
                _gutter: this.getConfig('gutter'),
                _size: this.size,
                _colCount: this.getConfig('colCount'),
              }, vnode.componentOptions.propsData),
            },
            vnode.componentOptions.children
          );
        }
        return vnode;
      })
    );
  },
};
</script>
